// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Footer__SocialIcon$PrezzeeRibbon from "./Footer__SocialIcon.bs.js";

function styling(theme) {
  var match = theme.components;
  var footer = match.footer;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector("span, a", [
                    BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
                    BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
                    BsCssJs$PrezzeeRibbon.transitionProperty("all"),
                    BsCssJs$PrezzeeRibbon.textDecoration(BsCssJs$PrezzeeRibbon.underline),
                    BsCssJs$PrezzeeRibbon.textDecorationColor("transparent"),
                    BsCssJs$PrezzeeRibbon.selector("." + Footer__SocialIcon$PrezzeeRibbon.Styles.socialIcon(theme), [
                          BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.fast),
                          BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeInOut"),
                          BsCssJs$PrezzeeRibbon.transitionProperty("all")
                        ]),
                    BsCssJs$PrezzeeRibbon.hover([
                          BsCssJs$PrezzeeRibbon.color(footer.hoverColor),
                          BsCssJs$PrezzeeRibbon.textDecorationColor(footer.hoverColor),
                          BsCssJs$PrezzeeRibbon.selector("." + Footer__SocialIcon$PrezzeeRibbon.Styles.socialIcon(theme), [
                                BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.backgroundColor(footer.iconHoverBackgroundColor)),
                                BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.color(footer.iconHoverColor))
                              ])
                        ])
                  ])]);
}

var Styles_white70 = {
  NAME: "hex",
  VAL: "FFFFFFB2"
};

var Styles = {
  white70: Styles_white70,
  styling: styling
};

function Footer__Link(props) {
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("li", {
                    children: props.children,
                    className: styling(theme)
                  })
            });
}

var make = Footer__Link;

export {
  Styles ,
  make ,
}
/* react/jsx-runtime Not a pure module */
